import React, { useContext } from "react";
import { generatePath, Navigate, useSearchParams } from "react-router-dom";
import track from "react-tracking";

import { Flex } from "@chakra-ui/react";

import Succeeded from "components/ProcessingPaymentView/Succeeded";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import { Loader } from "elements";
import useFetchOffers from "hooks/api/offers/useFetchOffers";
import { Offer } from "models/Offers";
import { useTrackCheckout, useTrackOnce } from "utils/tracking/hooks";

const PaymentSucceededPage = () => {
  const [searchParams] = useSearchParams();
  const { user } = useContext(SessionContext);
  const { isLoading: isLoadingOffers, isError: isErrorOffers, data } = useFetchOffers({ enabled: !!user });

  const paymentIntentId = searchParams.get("payment_intent") as string;

  const { trackSubscriptionFunnel } = useTrackCheckout();

  useTrackOnce(
    (setTracked) => {
      if (paymentIntentId) {
        trackSubscriptionFunnel("Succeed");
        setTracked();
      }
    },
    [paymentIntentId, trackSubscriptionFunnel]
  );

  if (isLoadingOffers) {
    return (
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Loader />
      </Flex>
    );
  }

  if (isErrorOffers) {
    return <Navigate to={generatePath(PAGE_PATHS.ERROR_PAGE)} />;
  }

  if (!data) {
    return null;
  }

  const offers = data.offers as Record<string, Offer>;
  const renewOffer = data.renewOffer as Offer;

  return paymentIntentId ? (
    <Succeeded offers={offers} renewOffer={renewOffer} />
  ) : (
    <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />
  );
};

export default track({ page_type: "Membership.Buy.PaymentSucceeded" })(PaymentSucceededPage);
